import React from 'react';
import { Overlay, AcCircularLoader } from '@appcharge/shared-ui';
import { useTranslation } from 'react-i18next';


export const Loader: React.FC<{ loaderAnimationUrl?: string }> = ({ loaderAnimationUrl }) => {
  const { t } = useTranslation();
  return (
     <Overlay overlayPercentage={90} zIndex={1500}>
        <AcCircularLoader text={t('processing')} animationUrl={loaderAnimationUrl}/>
     </Overlay>
  );
};

